<template>
    <div class="th-popup flex flex-col gap-8" >
        <div class="th-popup-header relative bg-popup flex flex-col gap-8 p-16 items-center" v-if="poi">
			<img :src="getPoiImage()" class="w-full h-160 object-cover rounded-md" v-if="getPoiImage()"/>
            <label class="poi-name text-24" v-html="poi.getName(language)" @v-touch:tap="onPOIClick(poi)"></label>
            <label class="p-4 px-6 text-12 pt-6 rounded-md">
                {{ getFirstGroup(poi) }}
            </label>
            <div class="absolute top-0 right-0 text-primary p-12 z-10" v-touch:tap="close()">
                <WFIcon name="close" class="w-14 h-14"></WFIcon>
            </div>      
        </div>
        
        <div class="th-popup-body p-8 flex flex-col gap-8" v-if="poi">
            <WFScrollableArea class="w-full max-h-128 pr-14">
                <div class="text-left font-normal" v-html="getDescription()" v-if="getDescription()"></div>
            </WFScrollableArea>
            
            <button class="btn poi-floor flex items-center justify-center p-12 leading-normal text-20 bg-active text-primary-content rounded-sm" v-touch:tap="showPath()" v-if="poi.getFloor()">
                <WFTranslate k="show_path" class="pt-2 leading-normal text-16"></WFTranslate>
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { WFIcon, WFTranslate } from '@3dwayfinder/wayfinder-vue-components'

export default {
    components: {
        WFTranslate,
        WFIcon
    },
    props: {
        poi: {
            default: null,
            type: Object
        }
    },
    data() {
        return {
            // Mock images for localhost testing
            mockImages: {
    'Anton Sport': 'https://picsum.photos/400/200',
    'Apotek 1': 'https://picsum.photos/400/200?random=1',
    'Meny': 'https://picsum.photos/400/200?random=2',
    'Ainas fotklinikk': 'https://picsum.photos/400/200?random=3',
    'default': 'https://picsum.photos/400/200?random=99'
}
        }
    },
	computed: {
		...mapState('wf', ['language']),
        isLocalhost() {
            return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        }
	}, 
    methods: {
        // Get POI image - with localhost mock fallback
        getPoiImage() {
            if (!this.poi) return null;
            
            // PRODUCTION: Try to get image from Wayfinder
            if (!this.isLocalhost) {
                // Try different possible method names
                const backgroundUrl = this.poi.getBackgroundUrl ? this.poi.getBackgroundUrl() : null;
                if (backgroundUrl) {
                    console.log('Using background URL:', backgroundUrl);
                    return backgroundUrl;
                }
                
                const logoUrl = this.poi.getLogoUrl ? this.poi.getLogoUrl() : null;
                if (logoUrl) {
                    console.log('Using logo URL:', logoUrl);
                    return logoUrl;
                }
                
                const iconUrl = this.poi.getIconUrl ? this.poi.getIconUrl() : null;
                if (iconUrl) {
                    console.log('Using icon URL:', iconUrl);
                    return iconUrl;
                }
            }
            
            // LOCALHOST: Use mock images for testing
            if (this.isLocalhost) {
                const poiName = this.poi.getName ? this.poi.getName(this.language) : '';
                console.log('Localhost: Using mock image for', poiName);
                return this.mockImages[poiName] || this.mockImages['default'];
            }
            
            return null;
        },

        getDescription() {
            if (!this.poi) return null;
            const desc = this.poi.getDescription ? this.poi.getDescription(this.language) : null;
            // Return null if description is false, empty, or just whitespace
            if (!desc || desc === false || desc === 'false' || (typeof desc === 'string' && desc.trim() === '')) {
                return null;
            }
            return desc;
        },
        
        getFirstGroup(poi) {
            if(typeof poi === "object") {
                return poi.getGroupNames(this.language).length > 0 ? poi.getGroupNames(this.language)[0] : '';
            }
            return "";
        },
        
        close () {
            return () => {
                this.$emit("close")
            };
        },
        
        showPath () {
            return () => {
                this.$emit("close");
                this.$emit("showPath", this.poi);
            }
        },
        
        isImage () {
            return this.getPoiImage() ? "image-visible" : "image-none";
		},
    }
}
</script>
<style scoped>
    .image-none {
        display: none;
    }
</style>